module.exports = __webpack_public_path__ + "static/media/svgicons8-ruler.4768fc1d.svg";